import { createApp } from "vue";
import { B2bToast, ModalHelper, bootbox } from "../../B2bTools";

import flatpickrVue from 'vue-flatpickr-component';
import hash from "../../hash";
import html from "./season.html";
import htmlLinelistDeliveryDates from "./season@LinelistDeliveryDates.html";
import htmlDeliveryDates from "./season@deliveryDates.html";
import htmlSeasonDrops from "./season@drops.html";
import htmlSeasonEdit from "./season@edit.html";
import htmlSeasonExclus from "./season@exclus.html";
import htmlSeasonMarkets from "./season@markets.html";
import htmlSeasonSection from "./season@section.html";
//import htmlSeasonStock from "./season@stock.html";

import { flatPickrConfig, may, toDate } from "../composant/b2bLangue";

import draggable from 'vuedraggable';
import Store from "../../Store";

const titles = {
    deliveryDates: [
        'Division',
        'Incoterm',
        'Start date',
        'End date'
    ],
    markets: [
        'OrderType',
        'Delivery Dates',
        'Active',
        'Updatable',
    ],
    exclus: [
        'Name',
        'Created',
        'Last Update',
        'User',
    ]
}

const js = ({
    url: function (echangeur) {

        /*!! 
            @Dev MB : 08/01/2024
            il faut trouver un moyen de passer l'environement 
            on ne récupère pas le hash avec echangeur.hash
        */

        let u = Store.get('getURUL')();
        if (!echangeur.hash.u) echangeur.hash.env = u;


        echangeur.addAction('b2b.codification.select', { classe: "soc" }, '', 'soc');
        echangeur.addAction('b2b.codification.select', { classe: "incoterm" }, '', 'incoterm');
        echangeur.addAction('b2b.codification.select', { classe: "orderdepartment" }, '', 'orderdepartment');
        echangeur.addAction('b2b.codification.select', { classe: "ordertype" }, '', 'ordertype');
        echangeur.addAction('b2b.codification.select', { classe: "market" }, '', 'market');
        echangeur.addAction('b2b.codification.select', { classe: "SEASON" }, '', 'season');
        echangeur.addAction('b2b.toc.edit', echangeur.hash, '', 'form');
        echangeur.addAction('b2b.page.edit', echangeur.hash, '', 'page');
        echangeur.addAction('b2b.env.getDefault', echangeur.hash, '', 'default');

        // echangeur.addAction('b2b.page.list', echangeur.hash, '', 'pagelist');
        // console.log('echangeur.pagelist', echangeur.pagelist)
    },
    onLoad: function (echangeur) {

        let THIS = this;
        const form = echangeur.form;
        const _id = form._id;
        const soc = echangeur.soc.rows;
        const orderdepartment = echangeur.orderdepartment.rows;
        const ordertype = echangeur.ordertype.rows;
        const incoterm = echangeur.incoterm.rows;
        const pages = echangeur.page.pages;
        const univers = Store.get('getURUL')();


        incoterm.unshift({ k: "zzzzz", v: "All" });
        incoterm.unshift({ k: "", v: "..." });
        //
        if (soc.length > 1) soc.unshift({ k: "", v: "..." });

        const isActive = (echangeur.default.rows && echangeur.default.rows.includes(form.k));
        const defaultMarket = echangeur.default.tocK;


        /*
            Ajout d'un market : "nomarket"
            Pour les produits importés et sans market M1RE M2NY ...
        */
        echangeur.market.rows.push({ k: "XXX", v: "no market" })


        /*
            INPROGRESS  : "10",	// brouillon
            VALIDATED   : "11",	// validée par l'acheteur
            CONFIRMED   : "9",	// envoyé ou en attente pour M3
            DELETED     : "99",
        */


        let CONFIRMED = (form.orders.filter(u => u.status == "9" && !u.numeroErp)).length;
        let VALIDATED = (form.orders.filter(u => u.status == "11")).length;
        let INPROGRESS = (form.orders.filter(u => u.status == "10")).length;

        //console.log(form.orders)

        const editableK = ((INPROGRESS + VALIDATED + CONFIRMED) == 0);

        if (!form.univer) {
            form.univer = univers;
        }

        //console.log('form', form)

        const app = createApp({
            data: () => ({
                showDeliveryDates: true,
                showMarkets: true,
                showExclus: true,
                editableK,
                datas: form,
                univer: univers,
                orderdepartment: orderdepartment,
                titles: titles,
                isEditeur: may("MAJSEASON"),
                pages: pages || [],
                isActive,
                defaultMarket,
            }),

            methods: {

                back() {
                    hash.fin();
                },

                getIconStock(status) {
                    if (status) return "fa-solid fa-circle-check text-success pe-1";
                    return "fa-solid fa-circle-xmark text-danger pe-1";
                },

                async setDefault() {
                    const thisParent = this;
                    bootbox.confirm(
                        {
                            title: 'Set Default Market',
                            message: `Are you sure to change current market ?
                            <div class="text-danger">
                                <b>Be carefull</b>, this will impact all users and orders.
                            </div>`
                        },
                        async function () {
                            const retour = await THIS.rest("b2b.env.setDefault", { _id: thisParent.datas._id, tocK: thisParent.datas.k, env: univers });
                            if (retour.ok) {
                                thisParent.defaultMarket = thisParent.datas.k
                                //const retour = await THIS.rest("b2b.env.activeToc", { _id: thisParent.datas._id, active: false, tocK: thisParent.datas.k });
                                B2bToast(`${thisParent.datas.k} is now the new default market`, 'success');
                            }
                        })
                },

                deleteDelivery(value) {
                    if (!this.isEditeur) return;
                    const sid = value.sid;
                    let usedIn = "";
                    for (const market of this.datas.markets) {
                        for (const row of market.rows) {
                            if (row.delivery == sid) {
                                if (!usedIn) usedIn = market.sid + "/" + row.ordertype
                            }
                        }
                    }

                    if (!usedIn) {
                        const thisParent = this;
                        bootbox.confirm(
                            {
                                title: 'Remove Delivery Dates',
                                message: `Are you sure to remove <b> ${value.v} </b> ?`
                            },
                            async function () {
                                const retour = await THIS.rest("b2b.toc.deleteDelivery", { _id, sid: value.sid });
                                thisParent.datas = retour.doc;
                            })
                    } else {
                        bootbox.alert(
                            {
                                title: 'Warning',
                                message: `Document is used in <b> ${usedIn} </b>`
                            })
                    }
                },


                // {
                //     title: 'Remove Delivery Dates',
                //     message: `Are you sure to remove <b> ${value.v} </b> ?`
                // },
                deleteMarket(value) {
                    if (!this.isEditeur) return;
                    const thisParent = this;
                    let total = value.rows.length
                    if (total == 0) {
                        bootbox.confirm(
                            {
                                title: 'Remove market',
                                message: `Are you sure to remove <b> ${value.sid} </b> ?`
                            },
                            async function () {
                                const retour = await THIS.rest("b2b.toc.deleteMarket", { _id, sid: value.sid });
                                thisParent.datas = retour.doc;
                            })
                    } else {
                        bootbox.alert(
                            {
                                title: 'Warning',
                                message: `There are <b> ${total} </b> row(s) left in ${value.sid}`
                            })
                    }
                },
                deleteExclus(value) {
                    if (!this.isEditeur) return;
                    const thisParent = this;
                    let total = value.products ? value.products.length : 0
                    if (total == 0) {
                        bootbox.confirm(
                            {
                                title: 'Remove Exclus',
                                message: `Are you sure to remove <b> ${value.v} </b> ?`
                            },
                            async function () {
                                const retour = await THIS.rest("b2b.toc.deleteExclus", { _id, sid: value.sid });
                                thisParent.datas = retour.doc;
                            })
                    } else {
                        bootbox.alert(
                            {
                                title: 'Warning',
                                message: `There are <b> ${total} </b> product(s) left in ${value.v}`
                            })
                    }
                },

                /* 
                    Edition des pages
                */
                async seasonPage() {
                    const result = await THIS.rest("b2b.toc.page", { "_id": _id, env: univers }, form);
                    if (result.ok) hash.lance('pagebuilder', { page: result.doc.page0, modeEdit: true });
                },

                toDate(value) {
                    return toDate(value);
                },
                toIncoterm(k) {
                    const option = incoterm.find(u => (u.k == k));
                    return (option) ? option.v : k;
                },
                toSoc(k) {
                    const option = soc.find(u => (u.k == k));
                    return (option) ? option.v : k;
                },
                toOrdertype(k) {
                    const option = ordertype.find(u => (u.k == k));
                    return (option) ? option.v : k;
                },
                toDelivery(sid) {
                    const option = this.datas.deliveries.find(u => (u.sid == sid));
                    return (option) ? option.v : sid;
                },
                toOrderdepartment(k) {
                    const option = orderdepartment.find(u => (u.k == k));
                    return (option) ? option.v : k;
                },
                labelPeriod(e) {
                    const a = this.datas.periods.find(u => u._id == e)
                    if (a) {
                        return a.v
                    } else {
                        return "Undefined"
                    }
                },

                exclusEdit(form) {
                    hash.lance("seasonExclusEdit", { _id: _id, sid: form.sid });
                },

                // stockEdit() {
                //     const thisParent = this;
                //     const modaleApp = createApp({
                //         data: function () {
                //             return {
                //                 saisie: {
                //                     rupture: "global",
                //                     withdelivdates: thisParent.datas.withdelivdates,
                //                     tbcstart: thisParent.datas.tbcstart,
                //                     tbcend: thisParent.datas.tbcend,
                //                 },
                //                 error: {},
                //                 options: [
                //                     { k: 'global', v: "Global" },
                //                     { k: 'dept', v: "Order Department" },
                //                     { k: 'family', v: "Family" }
                //                 ],
                //             }
                //         },
                //         methods: {
                //             close: function () {
                //                 ModalHelper.hide();
                //             },
                //             async saveForm() {
                //                 const thisVue = this;
                //                 const form = {
                //                     "withdelivdates": this.saisie.withdelivdates,
                //                     "env": this.univers,
                //                     "season": this.saisie.season,
                //                     "onstock": thisParent.datas.onstock,
                //                 }

                //                 if (!this.saisie.withdelivdates) {
                //                     form.tbcstart = this.saisie.tbcstart;
                //                     form.tbcend = this.saisie.tbcend;
                //                 } else {
                //                     this.saisie.tbcstart = "";
                //                     this.saisie.tbcend = "";
                //                 }

                //                 // if (Object.values(form).every(x => x)) {
                //                 const result = await THIS.rest("b2b.toc.saveHeaderStock", { "_id": _id }, form);
                //                 thisParent.datas = result.doc;
                //                 this.close()
                //                 // }
                //             },
                //         },
                //         mounted() {
                //             ModalHelper.show(async function () {
                //                 modaleApp.unmount();
                //             });
                //         }
                //     })
                //     modaleApp.mount(ModalHelper.html(htmlSeasonStock).container);
                // },


                seasonEdit() {
                    if (!this.isEditeur || !this.editableK) return;
                    const thisParent = this;
                    if (thisParent.datas.onstock === undefined) thisParent.datas.onstock = false;
                    const modaleApp = createApp({
                        data: function () {
                            return {
                                saisie: { ...thisParent.datas },
                                univers: univers,
                                error: {},
                                options: {
                                    market: echangeur.market.rows,
                                    season: echangeur.season.rows,
                                },
                                flatPickrConfig: flatPickrConfig,
                            }
                        },
                        components: {
                            'flatpickr-vue': flatpickrVue
                        },
                        methods: {
                            close: function () {
                                ModalHelper.hide();
                            },

                            async updateDisplayStock() {
                                const result = await THIS.rest("b2b.env.get", echangeur.hash);
                                const testStocks = (result.tocs.filter(u => u.onstock === true).length > 0) // 1 pour test @flo
                                const selector = document.querySelector('#asideimportstock')

                                if (testStocks) {
                                    selector.style.display = "block"
                                } else {
                                    selector.style.display = "none"
                                }
                            },

                            async save() {

                                const thisVue = this;

                                const form = {
                                    "k": String(this.saisie.k).replaceAll(/\s/g, '').toUpperCase(),
                                    "v": this.saisie.v,
                                    "codem3": this.saisie.codem3,
                                    "univer": this.saisie.univer,
                                    "dateMinimum": this.saisie.dateMinimum,
                                    "market": this.saisie.market,
                                    "season": this.saisie.season,
                                    "onstock": this.saisie.onstock,
                                    "edi": this.saisie.edi,
                                    "bulk": this.saisie.bulk,
                                    "withdelivdates": this.saisie.withdelivdates,
                                    "env": this.univers,
                                    "tbcstart": this.saisie.tbcstart,
                                    "tbcend": this.saisie.tbcend,
                                }

                                // if (!this.saisie.withdelivdates) {
                                //     form.tbcstart = this.saisie.tbcstart;
                                //     form.tbcend = this.saisie.tbcend;
                                // }
                                // else {
                                //     this.saisie.tbcstart = "";
                                //     this.saisie.tbcend = "";
                                // }
                                // Object.values(form).map((x, i) => {
                                //     thisVue.error[Object.keys(form)[i]] = (!x)
                                // })

                                // if (Object.values(form).every(x => x)) {
                                const result = await THIS.rest("b2b.toc.saveHeader", { "_id": _id }, form);
                                thisParent.datas = result.doc;

                                this.updateDisplayStock()
                                this.close()
                                // }

                            },
                        },
                        mounted() {

                            ModalHelper.show(async function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlSeasonEdit).container);
                },



                async seasonArchive() {
                    const thisParent = this;

                    //  On vérifie qu'il y a au moins une saison et qu'elle n'est pas active
                    // "et qu'elle n'est pas active" =>  à prouver 🙀
                    //
                    if (!this.isEditeur) return;
                    if (this.isActive) return;
                    const toclist = await THIS.rest('b2b.toc.list', { env: univers }, '', 'toc');
                    if (toclist.rows.length <= 1) return;

                    bootbox.confirm(
                        {
                            title: 'Archive Market',
                            message: `Are you sure to archive <b>${thisParent.datas.k} </b> ?`
                        },
                        async function () {
                            const result = await THIS.rest("b2b.linelist.archive", { idToc: thisParent.datas._id });
                            //"season": thisParent.datas.k,env:univers 
                            if (result.ok) {
                                B2bToast(`${thisParent.datas.k} successfully archived`, 'success');
                                hash.fin();
                            }
                        })
                },

                async activeMarket() {
                    if (!this.editableK && this.isActive) return;
                    const active = this.isActive = !this.isActive;
                    const retour = await THIS.rest("b2b.env.activeToc", { _id, active, tocK: this.datas.k, env: this.univers });
                },

                async activePublished() {
                    const published = this.datas.published = !this.datas.published;
                    const retour = await THIS.rest("b2b.toc.published", { _id, published });
                },

                async seasonDeliveryDates(data) {
                    if (!this.isEditeur) return;
                    const thisParent = this;
                    const form = await THIS.rest("b2b.toc.editDelivery", { _id, sid: data.sid });

                    let iKey = 0;
                    form.rows.forEach(element => {
                        element.error = {}
                        element.key = "key" + iKey++;
                    });
                    const modaleApp = createApp({
                        data: function () {
                            return {
                                sid: form.sid,
                                v: form.v,
                                rows: form.rows,
                                titles: titles,

                                options: {
                                    incoterm: incoterm,
                                    soc: soc,
                                },
                                errorTitle: false,
                                flatPickrConfig: flatPickrConfig,
                            }
                        },
                        components: {
                            'flatpickr-vue': flatpickrVue
                        },
                        methods: {
                            close() {
                                ModalHelper.hide();
                            },
                            add() {
                                this.rows.push({ soc: "", incoterm: "", dateStart: "", dateEnd: "", error: {}, key: "key" + iKey++ })
                            },
                            deleteRow(i) {

                                this.rows.splice(i, 1);

                            },
                            async save(e) {
                                e.preventDefault();
                                let nbError = 0;
                                this.errorTitle = false

                                if (!this.v) {
                                    this.errorTitle = true;
                                    nbError++;
                                }

                                const keys = {};
                                for (let item of this.rows) {
                                    item.error = {};
                                    if (!item.soc) item.error.soc = 'Division is empty';
                                    if (!item.incoterm) item.error.incoterm = 'Incoterm is empty';
                                    if (!item.dateStart) item.error.date = 'Date start is empty';
                                    else if (!item.dateEnd) item.error.date = 'Date end is empty';
                                    else if (item.dateStart > item.dateEnd) item.error.date = 'Date end is before date start ' + ([item.dateStart, item.dateEnd]).join(", ");
                                    //
                                    nbError += Object.keys(item.error).length;
                                    if (!nbError) {
                                        const key = item.soc + item.incoterm
                                        if (keys[key]) {
                                            nbError++;
                                            item.error.soc = "duplicate";
                                        } else {
                                            keys[key] = true;
                                        }
                                    }

                                }

                                if (!nbError) {
                                    const data = {
                                        sid: this.sid,
                                        v: this.v,
                                        rows: this.rows,
                                    }
                                    const result = await THIS.rest("b2b.toc.saveDelivery", { _id }, data);
                                    thisParent.datas = result.doc;
                                    this.close()
                                }
                            },
                        },
                        mounted() {
                            if (this.rows == 0) this.add()
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlDeliveryDates).container);
                },

                async seasonLinelistDeliveryDates() {
                    if (!this.isEditeur) return;

                    const thisParent = this;

                    const modaleApp = createApp({
                        data: function () {
                            return {
                                form,
                                dateStart: thisParent.datas.exportDeliveries?.dateStart || "",
                                dateEnd: thisParent.datas.exportDeliveries?.dateEnd || "",
                                flatPickrConfig: flatPickrConfig,
                                error: [],
                            }
                        },
                        components: {
                            'flatpickr-vue': flatpickrVue
                        },
                        methods: {
                            close() {
                                ModalHelper.hide();
                            },
                            async save(e) {
                                e.preventDefault();

                                this.error = [];

                                const data = {
                                    dateStart: this.dateStart,
                                    dateEnd: this.dateEnd,
                                }

                                if (!data.dateStart) this.error.push("Date start is empty")
                                if (!data.dateEnd) this.error.push("Date end is empty")
                                if (data.dateStart > data.dateEnd) this.error.push("Date end is before date start")

                                if (this.error.length === 0) {
                                    const result = await THIS.rest("b2b.toc.saveLinelistDelivery", { _id }, data);
                                    thisParent.datas = result.doc;
                                    this.close()
                                }

                            }
                        },
                        mounted() {
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlLinelistDeliveryDates).container);
                },

                async seasonDrops() {
                    if (!this.isEditeur) return;
                    const thisParent = this;
                    const sdoc = await THIS.rest("b2b.toc.editDrops", { _id });
                    const rows = sdoc.rows;

                    const rowsExistantes = await THIS.rest("b2b.linelist.drops", { classe: "deliverytheme" }, { tocK: thisParent.datas.k, env: univers });



                    for (const existant of rowsExistantes) {
                        if (!rows.find(u => u.k == existant.k)) {
                            rows.push(existant);
                        }
                    }
                    rows.forEach(element => {
                        element.error = {}
                    });
                    const modaleApp = createApp({

                        data: function () {
                            return {
                                rows: rows,
                                options: {
                                },
                                drag: false,
                            }
                        },
                        components: {
                            draggable,
                        },
                        methods: {
                            addRow() {
                                this.rows.push({ k: "", v: "", error: {} })
                            },
                            close: function () {
                                ModalHelper.hide();
                            },
                            async saveForm(e) {
                                e.preventDefault();

                                let nbError = 0;
                                for (let item of this.rows) {
                                    item.error = {};
                                    if (!item.v) item.error.v = 'Required';
                                    function nbe(objet) {
                                        let nb = 0;
                                        for (let key in objet) if (objet[key]) nb++;
                                        return nb;
                                    }
                                    nbError += nbe(item.error);
                                }

                                if (!nbError) {
                                    const data = {
                                        rows: this.rows.map(u => ({ k: u.k, v: u.v, })),
                                    }
                                    const result = await THIS.rest("b2b.toc.saveDrops", { _id }, data);
                                    thisParent.datas = result.doc;
                                    this.close();
                                }

                            },
                        },
                        mounted() {
                            if (this.rows == 0) this.addRow()
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlSeasonDrops).container);
                },

                async seasonMarkets(data) {
                    if (!this.isEditeur) return;

                    const thisParent = this;
                    const form = await THIS.rest("b2b.toc.editMarket", { _id, sid: data.sid });

                    let objMarkets = {}

                    thisParent.datas.markets.forEach(u => {
                        if (u.sid != data.sid) objMarkets[u.sid] = u
                    })

                    let choixPossible = [];
                    orderdepartment.map(u => {
                        if (!objMarkets[u.k]) choixPossible.push(u);
                    })
                    let iKey = 0;

                    form.rows.forEach(element => {
                        element.error = {};
                        element.key = "key" + iKey++;

                    });

                    const modaleApp = createApp({

                        data: function () {

                            return {
                                isnew: (!data.sid),
                                sid: form.sid,
                                rows: form.rows,
                                withdelivdates: form.withdelivdates,
                                v: form.v,
                                options: {
                                    deliveries: form.deliveries,
                                    ordertype: ordertype,
                                    orderdepartment: choixPossible
                                },
                                errorSid: false,
                                orderdepartmentEmpty: false
                            }

                        },
                        methods: {
                            deleteRow(i) {
                                this.rows.splice(i, 1);
                            },
                            toOrdertype(k) {
                                const option = ordertype.find(u => (u.k == k));
                                return (option) ? option.v : k;
                            },
                            close: function () {
                                ModalHelper.hide();
                            },
                            add() {
                                this.rows.push({ ordertype: "", delivery: "", status: "", updatable: "", error: {}, key: "key" + iKey++ })
                            },
                            toOrderdepartment(k) {
                                const option = orderdepartment.find(u => (u.k == k));
                                return (option) ? option.v : k;
                            },
                            async saveForm(e) {
                                e.preventDefault();

                                this.options.ordertype.find(u => (u.k == e));

                                let nbError = 0;

                                this.errorSid = false;
                                if (!this.sid) {
                                    this.errorSid = true;
                                    nbError++;
                                }
                                const keys = {};
                                for (let item of this.rows) {
                                    item.error = {};
                                    if (!item.ordertype) item.error.ordertype = 'Required';
                                    //if (!item.delivery) item.error.delivery = 'Required';

                                    nbError += Object.keys(item.error).length;

                                    if (!nbError) {
                                        const key = item.ordertype;
                                        if (keys[key]) {
                                            nbError++;
                                            item.error.ordertype = "Duplicate";
                                        } else {
                                            keys[key] = true;
                                        }
                                    }
                                }
                                //if (!item.codem3) this.error.codem3 = 'Code M3 is empty';


                                if (!nbError) {
                                    const data = {
                                        sid: this.sid,
                                        rows: this.rows.map(u => ({
                                            ordertype: u.ordertype,
                                            delivery: u.delivery,
                                            updatable: (u.updatable) ? true : false,
                                            status: (u.status) ? true : false
                                        })),
                                    }
                                    const result = await THIS.rest("b2b.toc.saveMarket", { _id, sid: data.sid }, data);
                                    thisParent.datas = result.doc;
                                    this.close()
                                }
                            },
                        },
                        mounted() {
                            if (this.options.orderdepartment.length == 0) {
                                this.orderdepartmentEmpty = true
                            }
                            if (this.rows == 0) this.add()
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlSeasonMarkets).container);
                },

                async seasonSection() {
                    if (!this.isEditeur) return;
                    const thisParent = this;
                    const form2 = await THIS.rest("b2b.toc.editSection", { _id });
                    let ikey;

                    form2.rows.forEach(element => {
                        element.error = {}
                        element.key = "K" + ikey++
                    });

                    const modaleApp = createApp({

                        data: function () {
                            return {
                                rows: form2.rows,
                                options: {
                                },
                                drag: false,
                            }
                        },
                        components: {
                            draggable,
                        },
                        methods: {
                            deleteRow(i) {
                                this.rows.splice(i, 1);
                            },
                            addRow() {
                                this.rows.push({ k: "", v: "", error: {}, key: "K" + ikey++ })
                            },
                            close: function () {
                                ModalHelper.hide();
                            },
                            async saveForm(e) {
                                e.preventDefault();

                                let nbError = 0;
                                const keys = {};
                                for (let item of this.rows) {
                                    item.error = {};
                                    if (!item.v) item.error.v = 'Required';
                                    nbError += Object.keys(item.error).length;
                                    if (!nbError) {
                                        const key = item.v;
                                        if (keys[key]) {
                                            nbError++;
                                            item.error.v = "Duplicate";
                                        } else {
                                            keys[key] = true;
                                        }
                                    }
                                }

                                if (!nbError) {
                                    const data = {
                                        rows: this.rows.map(u => ({ k: u.k, v: u.v, })),
                                    }
                                    const result = await THIS.rest("b2b.toc.saveSection", { _id }, data);
                                    thisParent.datas = result.doc;
                                    this.close();
                                }

                            },
                        },
                        mounted() {
                            if (this.rows == 0) this.addRow()
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlSeasonSection).container);
                },

                async seasonExclus() {
                    if (!this.isEditeur) return;
                    const thisParent = this;
                    const modaleApp = createApp({
                        data: function () {
                            return {
                                v: '',
                                orderdepartment: "",
                                error: {
                                    v: "", orderdepartment: ""
                                },
                                options: {
                                    orderdepartment: orderdepartment
                                }
                            }
                        },
                        methods: {
                            close: function () {
                                ModalHelper.hide();
                            },
                            reset() {
                                this.error.v = false
                                this.error.orderdepartment = false
                            },
                            async save() {

                                const thisVue = this;
                                this.reset()

                                function nbe() {
                                    let nb = 0;
                                    for (let key in thisVue.error) if (thisVue.error[key]) nb++;
                                    return nb;
                                }

                                const form = {
                                    "v": this.v,
                                    "orderdepartment": this.orderdepartment,
                                }

                                if (!form.v) this.error.v = "Required"
                                if (!form.orderdepartment) this.error.orderdepartment = "Required"

                                if (!nbe()) {
                                    const result = await THIS.rest("b2b.toc.createExclus", { "_id": _id }, form);
                                    thisParent.datas = result.doc;
                                    this.close()
                                    hash.lance("seasonExclusEdit", { _id: _id, sid: result.sdoc.sid });
                                }
                            },
                        },
                        mounted() {
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlSeasonExclus).container);
                }

            }
        });

        this.vm = app.mount(THIS.c$('._vueChargement')[0]);

    },
    reprise: async function (ecran, echangeur) {

        const form = await this.rest('b2b.toc.edit', echangeur.hash);

        //
        this.vm.$data.datas = form;
        //
        this.toggle(true);
        ecran.restaure();
        //


    }

});

export default {
    season: { js: js, html: html }
};



